import { Injectable } from "@angular/core";
import { ConnectionServices } from "../authentication/connection/connection.service";
import { IdentityService } from "../authentication/identity.service";
import { ConfigService } from "../authentication/connection/config.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { VehicleTypeResponseDto } from "../authentication/connection/interfaces/apiInterfaces";
import { GetVehicleTypeCommand } from "./command/getVehicleType.command";
import { IGetVehiclesTypeCommandParameters } from "./command/getVehicleType.command";
import { AddServiceTypeCommand } from "./command/addServiceType.command";
import { ServiceTypeDTO } from "./command/addServiceType.command";
import { GetServicesTypeDetailCommand } from "./command/getServiceTypeDetail.command";
import { ServiceTypeResponseDTO } from "./command/getServiceTypeDetail.command";
import { UpdateServiceTypeCommand } from "./command/updateServiceType.command";
import { GetEmployeesGrantsCommand } from "./command/getEmployeesGrants.command";
import { IGetEmployeesGrantsCommandParameters } from "./command/getEmployeesGrants.command";
import { EmployeeDto } from "./command/getEmployeesGrants.command";
import { GetEmployeesWithoutGrantsCommand } from "./command/getEmployeesWithoutGrants.command"; 
import { IGetEmployeesWithoutGrantsCommandParameters } from "./command/getEmployeesWithoutGrants.command";
import { GetIconsServicesTypeCommand, IGetIconsServicesTypeCommandParameters } from "./command/getIconsServices.command";

@Injectable()       
export class VehicleTypeService {
  private apiUrl: string;
  constructor(
    private _connectionService: ConnectionServices,
    private _identityService: IdentityService,
    private _configService: ConfigService,
    private _httpService: HttpClient,
  ) {
    this.apiUrl = this._configService.config.apiUrl;
  }

  public getVehiclesType(
    carrierHasCars?: boolean,
    carrierId?: string
  ): Observable<VehicleTypeResponseDto[]> {
    const vehicleCommand = new GetVehicleTypeCommand();
    let carrId = carrierId ? carrierId : this._identityService.userId;
    vehicleCommand.setParameters(<IGetVehiclesTypeCommandParameters>{
      carrierId: carrId,
      carrierHasCars: carrierHasCars,
    });
    return this._connectionService
      .Request(vehicleCommand)
      .pipe(
        map((data) => (data as unknown) as VehicleTypeResponseDto[]),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  public getVehiclesTypeByCarrier(
    carrierId: string,
    carrierHasCars?: boolean,
    serviceTypeId = null
  ): Observable<VehicleTypeResponseDto[]> {
    const vehicleCommand = new GetVehicleTypeCommand();
    vehicleCommand.setParameters(<IGetVehiclesTypeCommandParameters>{
      carrierId: carrierId,
      carrierHasCars: carrierHasCars,
      serviceTypeId: serviceTypeId
    });
    return this._connectionService
      .Request(vehicleCommand)
      .pipe(
        map((data) => (data as unknown) as VehicleTypeResponseDto[]),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  getAllTypesData(url: string): Observable<any> {
    let headersAppend = new HttpHeaders();
    headersAppend = headersAppend.append(
      'Authorization',
      `Bearer ${this._identityService.sessionToken}`
    );

    let options = {
      headers: headersAppend,
    };
    return this._httpService
      .get(this.apiUrl + url, options)
      .pipe(
        map((result) => result),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  createServicesType(data: ServiceTypeDTO): Observable<any> {
    const command = new AddServiceTypeCommand();
    command.setParametersUrl(this._identityService.userId);
    command.setParameters(data);

    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  getServicesTypeDetail(serviceTypeId: number): Observable<ServiceTypeResponseDTO> {
    const command = new GetServicesTypeDetailCommand();
    command.setParameters({
      carrierId: this._identityService.userId,
      serviceTypeId: serviceTypeId
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response as ServiceTypeResponseDTO),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  updateServicesType(data: ServiceTypeDTO, serviceTypeId: number): Observable<any> {
    const command = new UpdateServiceTypeCommand();
    command.setParametersUrl(this._identityService.userId, serviceTypeId);
    command.setParameters(data);

    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  getEmployeesGrants(serviceTypeId: number): Observable<Array<EmployeeDto>> {
    const command = new GetEmployeesGrantsCommand();
    command.setParameters(<IGetEmployeesGrantsCommandParameters> {
      carrierId: this._identityService.userId,
      serviceTypeId: serviceTypeId ? serviceTypeId.toString() : null
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response as Array<EmployeeDto>),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  getEmployeesWithoutGrants(contractorId: string, serviceTypeId: number): Observable<Array<EmployeeDto>> {
    const command = new GetEmployeesWithoutGrantsCommand();
    command.setParameters(<IGetEmployeesWithoutGrantsCommandParameters> {
      carrierId: this._identityService.userId,
      contractorId: contractorId,
      serviceTypeId: serviceTypeId ? serviceTypeId.toString() : null
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response as Array<EmployeeDto>),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  getServicesTypesIcons(): Observable<Array<EmployeeDto>> {
    const command = new GetIconsServicesTypeCommand();
    command.setParameters(<IGetIconsServicesTypeCommandParameters> {
      carrierId: this._identityService.userId
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response as Array<EmployeeDto>),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }
}
